import { render, staticRenderFns } from "./EditMaklumatPeribadi.vue?vue&type=template&id=7712cee2&"
import script from "./EditMaklumatPeribadi.vue?vue&type=script&lang=js&"
export * from "./EditMaklumatPeribadi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports